import React from "react";
import { ButtonBase, ButtonBaseProps } from "@mui/material";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

type Props = ButtonBaseProps<NavLink>;

export const PaneListButton = (props: Props) => {
  return (
    <StyledButtonBase
      focusRipple
      focusVisibleClassName="focus-visible"
      component={NavLink}
      to={props.to}
      className={props.className}
    >
      {props.children}
    </StyledButtonBase>
  );
};

export const PaneListItemHoverActions = styled.div`
  display: none;
  transition: 150ms all;
  opacity: 0;
`;

const StyledButtonBase = styled(ButtonBase)<Props>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  height: 75px;
  width: 100%;
  padding: 0 17px;

  border-radius: 4px;
  background-color: #f1f1f1;
  color: #000000;
  font-weight: 500;

  &:hover {
    div${PaneListItemHoverActions} {
      visibility: visible;
      opacity: 1;
      display: flex;
    }
  }

  > .MuiSvgIcon-root {
    fill: #000000;
  }

  &.active {
    background-color: #3fabff;
    color: white;

    .MuiSvgIcon-root {
      fill: white;
    }
  }
`;
